<template>
  <div
    ref="kt_modal_send_mail"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_send_mail"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/communication/com011.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Enviar e-mail</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="fechar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-0">
          <div class="d-block">
            <div class="border-bottom">
              <div class="ms-2 me-2">
                <el-form-item label="Para" class="mb-0 align-items-center">
                  <el-tag
                    v-for="tag in tagsEmails"
                    :key="tag"
                    class="m-2"
                    closable
                    type="info"
                    size="large"
                    :disable-transitions="false"
                    @close="handleClose(tag)"
                  >
                    {{ tag }}
                  </el-tag>
                  <el-input
                    v-if="inputVisible"
                    ref="txtNovoEmail"
                    id="txtNovoEmail"
                    v-model="inputValue"
                    class="me-4 ms-2 mb-2"
                    size="large"
                    @keydown.stop.prevent.enter="handleInputConfirm"
                    @blur="handleInputConfirm"
                    clearable
                    type="email"
                  />
                  <el-button
                    v-else
                    class="button-new-tag ms-2 mb-2 mt-2"
                    size="small"
                    id="btnAdicionarNovoEmail"
                    @click="showInput"
                  >
                    + Novo email
                  </el-button>
                </el-form-item>
              </div>
            </div>
            <div class="border-bottom">
              <div class="ms-2 me-2">
                <input
                  class="form-control form-control-transparent border-0 min-h-45px"
                  placeholder="Assunto"
                  id="txtAssunto"
                  v-model="subject"
                />
              </div>
            </div>
            <div class="mb-0">
              <QuillEditor
                ref="txtMensagem"
                id="txtMensagem"
                class="bg-transparent border-0 h-350px px-3"
                theme="snow"
                placeholder="Mensagem..."
                :toolbar="toolbar"
                contentType="html"
                v-model:content="contentMail"
              />
            </div>
            <div class="m-2 d-flex flex-wrap" v-if="this.files">
              <div class="mt-2 me-2" v-for="file in this.files" :key="file">
                <a
                  class="d-flex align-items-center bg-light-secondary bg-hover-light-primary rounded text-hover-primary p-1"
                  @click="download(file)"
                >
                  <span class="svg-icon svg-icon-2 svg-icon-primary me-2">
                    <inline-svg src="media/icons/duotune/files/fil003.svg" />
                  </span>
                  <div class="fs-6 text-gray-700 p-1">
                    {{ file.nome }}
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            id="btnConfirmar"
            class="btn btn-primary svg-icon-white mb-2"
            v-bind:data-kt-indicator="this.loadingEnvio ? 'on' : 'off'"
            @click.prevent="confirmarEnvio()"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loadingEnvio">
              <inline-svg
                src="media/icons/duotune/general/gen016.svg"
                class="me-2"
              />Enviar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
import { ElInput } from "element-plus";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

export default {
  emits: ["exibirModalMail"],
  components: {
    QuillEditor,
  },
  props: {
    show: { type: Boolean, required: true },
    emails: { type: Array, required: true },
    assunto: { type: String, required: true },
    mensagem: { type: String, required: true },
    anexos: { type: Array, required: false },
  },
  methods: {
    fechar() {
      hideModal(this.$refs.kt_modal_send_mail);
      this.$emit("exibirModalMail", false);
    },
    handleClose(tag) {
      this.tagsEmails.splice(this.tagsEmails.indexOf(tag), 1);
    },
    async showInput() {
      this.inputVisible = true;
      setTimeout(() => {
        document.getElementById("txtNovoEmail").focus();
      }, 100);
    },
    async handleInputConfirm() {
      if (this.inputValue) {
        if (this.inputValue !== "") {
          if (this.$utils.checkEmail(this.inputValue) === false) {
            this.tagsEmails.push(this.inputValue);
          } else {
            if (this.inputValue != this.inputValid) {
              this.inputValid = this.inputValue;
              await this.$swal.showInvalidAlert(
                "O e-mail informado é inválido!"
              );
            }
            return;
          }
        }
      }
      this.inputVisible = false;
      this.inputValue = "";
      setTimeout(() => {
        document.getElementById("btnAdicionarNovoEmail").focus();
      }, 100);
    },
    async validar() {
      let result = true;
      if (this.tagsEmails.length <= 0) {
        await this.$swal.showInvalidAlert(
          "Informe um e-mail para o envio!",
          (alert) => {
            this.$utils.requestFocus("btnAdicionarNovoEmail");
            result = false;
          }
        );
      }

      if (this.subject.toString().trim().length <= 0) {
        await this.$swal.showInvalidAlert(
          "Informe o assunto do e-mail!",
          (alert) => {
            this.$utils.requestFocus("txtAssunto");
            result = false;
          }
        );
      }
      var txtMensagemQuill = this.$refs["txtMensagem"].getQuill();
      if (txtMensagemQuill != null) {
        if (txtMensagemQuill.root.innerText.toString().trim().length <= 0) {
          await this.$swal.showInvalidAlert(
            "Informe uma mensagem!",
            (alert) => {
              txtMensagemQuill.focus();
              result = false;
            }
          );
        }
      }

      return result;
    },
    async confirmarEnvio() {
      this.loadingEnvio = true;
      var validado = await this.validar();

      if (validado === true) {
        var msg = this.$refs["txtMensagem"].getQuill().root.innerHTML;

        var email = {
          emails: this.tagsEmails,
          celular: "",
          titulo: this.subject,
          mensagem: msg,
          anexos: this.files,
        };

        try {
          var response = await this.$store.dispatch(
            "compartilhamento/enviarEmail",
            email
          );
          if (response.Success === true) {
            await this.$swal.showSuccessAlert(
              "Email enviado com sucesso!",
              (alert) => {
                this.fechar();
              }
            );
          }
        } catch (error) {
          await this.$swal.showInvalidAlert("Não foi possível enviar o email!");
        }
      }

      this.loadingEnvio = false;
    },
    async download(file) {
      var fileURL = [];
      var base64 = this.$utils.extractBase64Data(file.base64Arquivo);
      if (base64) {
        let blob = this.$utils.base64ToBlob(base64);
        fileURL = window.URL.createObjectURL(new Blob([blob]));
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", file.nome);
        document.body.appendChild(fileLink);
        fileLink.click();
      }
    },
  },
  mounted() {
    this.subject = this.assunto;
    this.contentMail = this.mensagem;
    this.tagsEmails = this.emails;
    this.files = this.anexos;
    const t = document.querySelector(".ql-toolbar");
    if (t) {
      const e = [
        "px-3",
        "border-top-0",
        "border-start-0",
        "border-end-0",
        "border-bottom",
      ];
      t.classList.add(...e);
    }
  },
  data() {
    return {
      subject: "",
      contentMail: "",
      inputValue: "",
      tagsEmails: [],
      inputValid: "",
      inputVisible: false,
      loadingEnvio: false,
      files: [],
      toolbar: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ align: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["image"],
      ],
    };
  },
};
</script>

<style></style>
